import lazyLoading from './config';

export default [
    {
        path: '/',
        name: 'api.new',
        meta: {
            title: '爱库存-API文档'
        },
        component: resolve => lazyLoading(resolve, 'apiDoc/new')
    },
    {
        path: '/delivery',
        redirect: {
            path: '/',
            query: { docType: '1', id: '440' }
        }
    }
];
